import { EmailFieldValidationMessages } from "types/fields";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

type ValidationMode = "boolean" | "strict";
type ValidationResult = boolean | string;

export function validateEmail(email: string, mode: ValidationMode = "boolean"): ValidationResult {
  const trimmed = email.trim();
  const emailFieldEmptyErrorMessage = EmailFieldValidationMessages.EmailFieldCantBeEmpty;
  const formatInvalidErrorMessage = EmailFieldValidationMessages.PleaseEnterAValidEmailFormat;

  if (mode === "boolean") {
    return emailRegex.test(trimmed);
  }

  if (trimmed === "") {
    return emailFieldEmptyErrorMessage;
  }

  if (!emailRegex.test(trimmed)) {
    return formatInvalidErrorMessage;
  }

  return true;
}
